const EXP = new Array(512);
const LOG = new Array(256);

(function initGf() {
  let value = 1;
  for (let i = 0; i < 255; i += 1) {
    EXP[i] = value;
    LOG[value] = i;
    value = value * 2 ^ (value >= 128 ? 0x11d : 0);
  }
  for (let i = 255; i < 512; i += 1) {
    EXP[i] = EXP[i - 255];
  }
}());

function mul(a, b) {
  return a && b ? EXP[LOG[a] + LOG[b]] : 0;
}

function rsRemainder(data, degree) {
  let gen = [1];
  for (let i = 0; i < degree; i += 1) {
    const next = new Array(gen.length + 1).fill(0);
    for (let j = 0; j < gen.length; j += 1) {
      next[j] ^= mul(gen[j], EXP[i]);
      next[j + 1] ^= gen[j];
    }
    gen = next;
  }
  const rest = data.concat(new Array(degree).fill(0));
  for (let i = 0; i < data.length; i += 1) {
    const factor = rest[i];
    if (!factor) {
      continue;
    }
    for (let j = 0; j < gen.length; j += 1) {
      rest[i + j] ^= mul(gen[j], factor);
    }
  }
  return rest.slice(data.length);
}

const VERSIONS = [
  { version: 1, size: 21, data: 16, ecc: 10 },
  { version: 2, size: 25, data: 28, ecc: 16 },
  { version: 3, size: 29, data: 44, ecc: 26 },
  { version: 4, size: 33, data: 64, ecc: 36 },
];

function chooseVersion(bytes) {
  const needed = bytes.length + 2;
  return VERSIONS.find((item) => item.data >= needed) || VERSIONS[VERSIONS.length - 1];
}

function encodeBytes(text, capacity) {
  const bytes = toBytes(text).slice(0, capacity - 2);
  const bits = [];
  const push = (value, length) => {
    for (let i = length - 1; i >= 0; i -= 1) {
      bits.push((value >> i) & 1);
    }
  };
  push(0b0100, 4);
  push(bytes.length, 8);
  bytes.forEach((byte) => push(byte, 8));
  const padBits = Math.min(4, capacity * 8 - bits.length);
  push(0, padBits);
  while (bits.length % 8) {
    bits.push(0);
  }
  const codewords = [];
  for (let i = 0; i < bits.length; i += 8) {
    codewords.push(parseInt(bits.slice(i, i + 8).join(""), 2));
  }
  const pads = [0xec, 0x11];
  while (codewords.length < capacity) {
    codewords.push(pads[(codewords.length - bytes.length) % 2]);
  }
  return codewords;
}

function reserve(matrix, size) {
  const mark = (r, c) => {
    if (r >= 0 && c >= 0 && r < size && c < size) {
      matrix[r][c] = matrix[r][c] === null ? false : matrix[r][c];
    }
  };
  const finder = (row, col) => {
    for (let r = -1; r <= 7; r += 1) {
      for (let c = -1; c <= 7; c += 1) {
        const inside = r >= 0 && r <= 6 && c >= 0 && c <= 6;
        const on = inside && (r === 0 || r === 6 || c === 0 || c === 6 || (r >= 2 && r <= 4 && c >= 2 && c <= 4));
        if (row + r >= 0 && col + c >= 0 && row + r < size && col + c < size) {
          matrix[row + r][col + c] = inside ? on : false;
        } else {
          mark(row + r, col + c);
        }
      }
    }
  };
  finder(0, 0);
  finder(0, size - 7);
  finder(size - 7, 0);
  if (size >= 25) {
    const center = size - 7;
    for (let r = -2; r <= 2; r += 1) {
      for (let c = -2; c <= 2; c += 1) {
        matrix[center + r][center + c] = Math.max(Math.abs(r), Math.abs(c)) !== 1;
      }
    }
  }
  for (let i = 8; i < size - 8; i += 1) {
    matrix[6][i] = i % 2 === 0;
    matrix[i][6] = i % 2 === 0;
  }
  for (let i = 0; i < 9; i += 1) {
    mark(8, i);
    mark(i, 8);
    mark(8, size - 1 - i);
    mark(size - 1 - i, 8);
  }
  mark(size - 8, 8);
}

function placeData(matrix, size, bits) {
  let index = 0;
  let up = true;
  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) {
      col -= 1;
    }
    for (let i = 0; i < size; i += 1) {
      const row = up ? size - 1 - i : i;
      for (let offset = 0; offset < 2; offset += 1) {
        const c = col - offset;
        if (matrix[row][c] === null) {
          matrix[row][c] = bits[index] === 1;
          index += 1;
        }
      }
    }
    up = !up;
  }
}

function maskBit(row, col) {
  return (row + col) % 2 === 0;
}

function applyMask(matrix, size) {
  for (let r = 0; r < size; r += 1) {
    for (let c = 0; c < size; c += 1) {
      if (typeof matrix[r][c] === "boolean" && !(
        (r < 9 && c < 9)
        || (r < 9 && c >= size - 8)
        || (r >= size - 8 && c < 9)
        || r === 6
        || c === 6
        || (size >= 25 && r >= size - 9 && r <= size - 5 && c >= size - 9 && c <= size - 5)
      )) {
        if (maskBit(r, c)) {
          matrix[r][c] = !matrix[r][c];
        }
      }
    }
  }
}

function setFormat(matrix, size) {
  const bits = "101010000010010".split("").map((bit) => bit === "1");
  const positions = [
    [8, 0], [8, 1], [8, 2], [8, 3], [8, 4], [8, 5], [8, 7], [8, 8],
    [7, 8], [5, 8], [4, 8], [3, 8], [2, 8], [1, 8], [0, 8],
  ];
  const mirror = [
    [size - 1, 8], [size - 2, 8], [size - 3, 8], [size - 4, 8], [size - 5, 8], [size - 6, 8], [size - 7, 8],
    [8, size - 8], [8, size - 7], [8, size - 6], [8, size - 5], [8, size - 4], [8, size - 3], [8, size - 2], [8, size - 1],
  ];
  bits.forEach((bit, i) => {
    matrix[positions[i][0]][positions[i][1]] = bit;
    matrix[mirror[i][0]][mirror[i][1]] = bit;
  });
  matrix[size - 8][8] = true;
}

function toBytes(text) {
  const value = String(text || "");
  if (typeof TextEncoder !== "undefined") {
    return Array.from(new TextEncoder().encode(value));
  }
  return Array.from(value).map((char) => char.charCodeAt(0) & 255);
}

export function qrMatrix(text) {
  const spec = chooseVersion(toBytes(text));
  const data = encodeBytes(String(text || ""), spec.data);
  const ecc = rsRemainder(data, spec.ecc);
  const bits = [...data, ...ecc].flatMap((byte) => (
    byte.toString(2).padStart(8, "0").split("").map((bit) => Number(bit))
  ));
  const matrix = Array.from({ length: spec.size }, () => Array(spec.size).fill(null));
  reserve(matrix, spec.size);
  placeData(matrix, spec.size, bits);
  applyMask(matrix, spec.size);
  setFormat(matrix, spec.size);
  return matrix.map((row) => row.map((cell) => Boolean(cell)));
}

export function qrSvg(text, size = 168) {
  const matrix = qrMatrix(text);
  const dim = matrix.length;
  const pad = 2;
  const total = dim + pad * 2;
  const cells = matrix.flatMap((row, y) => row.map((on, x) => (
    on ? `<rect x="${x + pad}" y="${y + pad}" width="1" height="1"/>` : ""
  )).join("")).join("");
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${total} ${total}" width="${size}" height="${size}" role="img" aria-label="QR Code ${text}"><rect width="${total}" height="${total}" fill="#fff"/>${cells}</svg>`;
}
